<template lang="pug">
  .notification
    .notification__header
      .notification__title(v-if="isAdmin") Новый пользователь в системе
      .notification__title(v-else) Добро пожаловать!
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        template(v-if="isAdmin")
          | Регистрация нового пользователя:
          br
          strong {{ payload.firmName }}
          br
          a(v-bind:href="'mailto:' + payload.firmEmail") {{ payload.firmEmail }}
        template(v-else)
          | Настройте свой ConPlus и начинайте работу.
          br
          router-link.notification__link(
            @click.native="emitClick"
            title="Настройки"
            to="/settings"
          ) Перейти к настройкам
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'FirmCreated',
  mixins: [notification]
};
</script>
